import React from "react";
import { createPortal } from "react-dom";
import { ChevronDown, X } from "lucide-react";
import { getReactPortalRoot } from "../utils/reactPortalRoot.js";
import "./DriverPortalDateMenu.css";

function DateDialog({ id, children, onClose }) {
  const dialogRef = React.useRef(null);
  const closeRef = React.useRef(null);

  React.useEffect(() => {
    const dialog = dialogRef.current;
    const opener = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = "hidden";
    closeRef.current?.focus({ preventScroll: true });
    return () => {
      dialog.close();
      document.body.style.overflow = previousOverflow;
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    };
  }, []);

  return createPortal(
    <dialog ref={dialogRef} id={id} className="driver-portal driver-date-dialog" aria-label="Choisir une journée"
      onCancel={(event) => { event.preventDefault(); onClose(); }}
      onClick={(event) => {
        if (event.target !== event.currentTarget) return;
        const rect = event.currentTarget.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) onClose();
      }}>
      <button ref={closeRef} type="button" className="driver-date-dialog__close" aria-label="Fermer le choix de journée" onClick={onClose}>
        <X size={20} aria-hidden="true" />
      </button>
      <div className="driver-date-dialog__body">{children}</div>
    </dialog>,
    getReactPortalRoot(),
  );
}

export default function DriverPortalDateMenu({ label, children }) {
  const [open, setOpen] = React.useState(false);
  const dialogId = React.useId();

  return (
    <>
      <button type="button" className="driver-date-trigger" aria-label={`${label} — changer de journée`}
        aria-haspopup="dialog" aria-expanded={open} aria-controls={open ? dialogId : undefined}
        title="Changer de journée" onClick={() => setOpen(true)}>
        {label}<ChevronDown size={12} aria-hidden="true" />
      </button>
      {open ? <DateDialog id={dialogId} onClose={() => setOpen(false)}>{children}</DateDialog> : null}
    </>
  );
}
